import { cn } from 'lib/utils'

import { Icon, iconMap, type IconName } from 'components/atoms/Icon'
import { Image, type ImageName } from 'components/atoms/Image'

import './index.scss'

const mainClass = 'logo'

const DEFAULT_DESKTOP_WIDTH = 64
const DEFAULT_DESKTOP_HEIGHT = 40
const DEFAULT_MOBILE_WIDTH = 40
const DEFAULT_MOBILE_HEIGHT = 40

interface LogoProps {
  src?: ImageName | IconName | string
  mobSrc?: ImageName | IconName | string
  alt?: string
  width?: number
  height?: number
  className?: string
}

const isIconName = (name: string): name is IconName => {
  return name in iconMap
}

export const Logo = ({
  src = 'logo',
  mobSrc = 'logo-small',
  alt = 'Logo',
  width,
  height,
  className = '',
}: LogoProps) => {
  const desktopSrc = src || 'logo'
  const mobileSrc = mobSrc || 'logo-small'
  const isDesktopIcon = isIconName(desktopSrc)
  const isMobileIcon = isIconName(mobileSrc)

  const desktopProps = {
    width: width ?? DEFAULT_DESKTOP_WIDTH,
    height: height ?? DEFAULT_DESKTOP_HEIGHT,
    className: cn(mainClass, className),
  }

  const mobileProps = {
    width: width ?? DEFAULT_MOBILE_WIDTH,
    height: height ?? DEFAULT_MOBILE_HEIGHT,
    className: cn(`${mainClass}--mob`, className),
  }

  if (isDesktopIcon && isMobileIcon) {
    return (
      <>
        <Icon name={desktopSrc} {...desktopProps} isColor />
        <Icon name={mobileSrc} {...mobileProps} isColor />
      </>
    )
  }

  return (
    <>
      <Image name={desktopSrc as ImageName} alt={alt} {...desktopProps} />
      <Image name={mobileSrc as ImageName} alt={alt} {...mobileProps} />
    </>
  )
}
